<template>
  <MenuRef :iShow="showColor" :openKeys="SubMenu">
    <div class="detalis">
      <div class="search-cond">
        <div class="search-input">
          <div class="search-item">
            <div class="tol-title">企业名称:</div>
            <a-input
              style="width: 434px; height: 40px; flex: 1 1 0%"
              v-model="form.companyName"
            />
          </div>
          <div class="search-item">
            <div class="tol-title">负责人:</div>
            <a-input
              style="width: 434px; height: 40px; flex: 1 1 0%"
              v-model="form.companyPerson"
            />
          </div>
          <div class="search-item">
            <div class="tol-title">电话:</div>
            <a-input
              style="width: 434px; height: 40px; flex: 1 1 0%"
              v-model="form.companyPhone"
            />
          </div>
        </div>
        <div class="search-input">
          <div class="search-item">
            <div class="tol-title">电销人员:</div>
            <a-input
              style="width: 434px; height: 40px; flex: 1 1 0%"
              v-model="form.salesman"
            />
          </div>
          <div class="search-item">
            <div class="tol-title">选择日期:</div>
            <a-config-provider :locale="locale">
              <a-range-picker
                :format="dateFormatList"
                style="width: 434px; height: 40px; flex: 1 1 0%"
                show-time
                v-model="timePicker"
                @change="getStartDatePicker"
                @clear="onDateClear"
            /></a-config-provider>
          </div>
          <div class="search-item">
            <div class="tol-title">是否邀约:</div>
            <a-select
              style="flex: 1; width: 434px; height: 40px"
              v-model="form.isInvite"
              placeholder="请选择"
            >
              <a-select-option :value="true">是</a-select-option>
              <a-select-option :value="false">否</a-select-option>
            </a-select>
          </div>
        </div>
        <div class="search-input">
          <div class="search-item"></div>
          <div class="search-item"></div>
          <div class="search-item" style="justify-content: flex-end">
            <div class="btn-cond">
              <div>
                <a-button @click="reset" class="search-normal"> 重置 </a-button>
                <a-button
                  class="search-btn"
                  :style="{ marginLeft: '24px' }"
                  @click="searchData"
                >
                  查询
                </a-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="detalis-box">
        <div class="detalis-view">
          <div class="tol-item">
            <div>
              <a-button class="search-btn" @click="openUpdate(1)"
                >新增</a-button
              >
            </div>
            <div>
              <a-button
                :style="{ marginLeft: '16px' }"
                class="search-normal"
                @click="openUpdate(2)"
              >
                修改
              </a-button>
            </div>
            <div>
              <a-button
                :style="{ marginLeft: '16px' }"
                class="search-normal"
                @click="exportData"
              >
                导出
              </a-button>
            </div>

            <div>
              <a-button
                :style="{ marginLeft: '16px' }"
                class="search-delete"
                @click="deleteData"
              >
                删除
              </a-button>
            </div>
          </div>
        </div>
        <div class="detalis-table" ref="tableContainer">
          <a-config-provider :locale="locale">
            <div>
              <a-table
                :customRow="customRow"
                class="detalis-table"
                ref="table"
                size="small"
                :rowSelection="rowSelection"
                :columns="columns"
                :data-source="tolInformation"
                :rowKey="(record, index) => index"
                :pagination="pagination"
              ></a-table>
            </div>
          </a-config-provider>
        </div>
      </div>
      <a-modal
        v-model="isModalVisible"
        @ok="detailUpdateOk"
        @cancel="detailUpdateCancel"
        scrollable
        title="CRM信息编辑"
        :ok-text="'确定'"
        :cancel-text="'取消'"
        :wrapClassName="'centered-modal'"
      >
        <a-spin :spinning="loading" tip="数据保存中...">
          <a-form :model="formData" ref="formData" :label-width="120">
            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-item style="display: flex" label="企业名称：">
                  <a-input
                    v-model="formData.companyName"
                    style="flex: 1; width: 434px; height: 40px"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item style="display: flex" label="负责人：">
                  <a-input
                    v-model="formData.companyPerson"
                    style="flex: 1; width: 434px; height: 40px"
                  />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-item style="display: flex" label="电话：">
                  <a-input
                    v-model="formData.companyPhone"
                    style="flex: 1; width: 434px; height: 40px"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item style="display: flex" label="地址：">
                  <a-input
                    style="flex: 1; width: 434px; height: 40px"
                    v-model="formData.companyAddress"
                  />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-item style="display: flex" label="电销次数：">
                  <a-input
                    style="flex: 1; width: 434px; height: 40px"
                    v-model="formData.telemarketingNumber"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item style="display: flex" label="是否加微信：">
                  <a-select
                    style="flex: 1; width: 434px; height: 40px"
                    placeholder="请输入"
                    v-model="formData.isWechat"
                  >
                    <a-select-option :value="false">否</a-select-option>
                    <a-select-option :value="true">是</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-item style="display: flex" label="电销人员：">
                  <a-input
                    style="flex: 1; width: 434px; height: 40px"
                    v-model="formData.salesman"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item style="display: flex" label="跟进情况：">
                  <a-input
                    style="flex: 1; width: 434px; height: 40px"
                    v-model="formData.name"
                  />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-item style="display: flex" label="加入日期：">
                  <a-config-provider :locale="locale">
                    <a-date-picker
                      style="flex: 1; width: 434px; height: 40px"
                      v-model="formData.dataTime"
                      format="YYYY-MM-DD"
                    />
                  </a-config-provider>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item style="display: flex" label="详情：">
                  <a-input
                    style="flex: 1; width: 434px; height: 40px"
                    v-model="formData.details"
                  />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-item style="display: flex" label="拜访记录：">
                  <a-input
                    style="flex: 1; width: 434px; height: 40px"
                    v-model="formData.visitLog"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item style="display: flex" label="是否邀约：">
                  <a-select
                    style="flex: 1; width: 434px; height: 40px"
                    placeholder="请输入"
                    v-model="formData.isInvite"
                  >
                    <a-select-option :value="false">否</a-select-option>
                    <a-select-option :value="true">是</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
          </a-form>
        </a-spin>
      </a-modal>
    </div>
  </MenuRef>
</template>

<script>
import moment from "moment";
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN";
import { getCRMList, upsertCRM, deleteCRM, exportCRMList } from "@/api";
import MenuRef from "./common/MenuRef";
import Cookies from "js-cookie";
import rolePermissions from "./rolePermissions.js";

export default {
  components: {
    MenuRef,
  },
  data() {
    return {
      permissions: {},
      SubMenu: ["sub-crm"],
      showColor: ["8"],
      form: {
        companyName: "",
        companyPerson: "",
        companyPhone: "",
        salesman: "",
        isInvite: "",
      },
      formData: {
        companyName: "",
        companyPerson: "",
        companyPhone: "",
        companyAddress: "",
        telemarketingNumber: "",
        isWechat: false,
        details: "",
        salesman: "",
        name: "",
        dataTime: moment(),
        visitLog: "",
        isInvite: false,
      },
      locale: zhCN,
      dateFormat: "YYYY-MM-DD HH:mm:ss",
      indexNum: 1,
      tolInformation: [],
      columns: [
        {
          title: "序号",
          key: "index",
          align: "center",
          customRender: (text, record, index) =>
            `${(this.indexNum - 1) * this.indexNum + index + 1}`,
        },
        {
          title: "记录日期",
          dataIndex: "createAt",
          align: "center",
          customRender: (text, record, index) => {
            return moment(record.createdAt).format("YYYY-MM-DD");
          },
        },
        {
          title: "公司名称",
          dataIndex: "companyName",
          align: "center",
          customRender: (text, record, index) => {
            return record.companyName || "/";
          },
        },
        {
          title: "负责人",
          dataIndex: "companyPerson",
          align: "center",
          customRender: (text, record, index) => {
            return record.companyPerson || "/";
          },
        },
        {
          title: "电话",
          dataIndex: "companyPhone",
          align: "center",
          customRender: (text, record, index) => {
            return record.companyPhone || "/";
          },
        },
        {
          title: "地址",
          dataIndex: "companyAddress",
          align: "center",
          customRender: (text, record, index) => {
            return record.companyAddress || "/";
          },
        },
        {
          title: "电销次数",
          dataIndex: "telemarketingNumber",
          align: "center",
          customRender: (text, record, index) => {
            return record.telemarketingNumber || 0;
          },
        },
        {
          title: "是否加微信",
          dataIndex: "weChat",
          align: "center",
          customRender: (text, record, index) => {
            let h = this.$createElement;
            return h("a-switch", {
              style: {
                width: "48px",
                height: "24px",
              },
              props: {
                checked: record.isWechat,
                checkedChildren: "是",
                unCheckedChildren: "否",
              },
            });
          },
        },
        {
          title: "是否邀约",
          dataIndex: "isInvite",
          align: "center",
          customRender: (text, record, index) => {
            let h = this.$createElement;
            return h("a-switch", {
              style: {
                width: "48px",
                height: "24px",
              },
              props: {
                checked: record.isInvite,
                checkedChildren: "是",
                unCheckedChildren: "否",
              },
            });
          },
        },
        {
          title: "详情",
          dataIndex: "details",
          align: "center",
          customRender: (text, record, index) => {
            return record.details || "/";
          },
        },
        {
          title: "电销人员",
          dataIndex: "salesman",
          align: "center",
          customRender: (text, record, index) => {
            return record.salesman || "/";
          },
        },
        {
          title: "跟进情况",
          dataIndex: "name",
          align: "center",
          customRender: (text, record, index) => {
            return record.name || "/";
          },
        },
        {
          title: "拜访记录",
          dataIndex: "visitLog",
          align: "center",
          customRender: (text, record, index) => {
            return record.visitLog || "/";
          },
        },
      ],
      tableHeight: 259,
      pageSize: 12,
      pagination: {
        pageNo: 1,
        pageSize: 12, // 默认每页显示数量
        showSizeChanger: false, // 显示可改变每页数量
        showQuickJumper: true,
        pageSizeOptions: ["15", "20", "30", "50"], // 每页数量选项
        showTotal: (total) => `共${total}条`, // 显示总数
        onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
        onChange: this.onPageChange.bind(this), //点击页码事件
        total: 0, //总条数
        current: 0,
        buildOptionText: (pageSizeOptions) => `${pageSizeOptions.value}条/页`,
        size: "middle",
      },
      selectRow: [],
      loading: false,
      isModalVisible: false,
      timePicker: [],
      dateFormatList: ["YYYY-MM-DD HH:mm:ss", "YYYY-MM-DD HH:mm:ss"],
    };
  },
  methods: {
    moment,
    onDateClear() {
      this.startDate = null;
      this.endDate = null;
      this.timePicker = [null, null];
    },
    getStartDatePicker(date) {
      this.startDate = moment(date[0]);
      this.endDate = moment(date[1]);
    },
    openUpdate(type) {
      if (type == 1) {
        this.isModalVisible = true;
        this.formData = {
          companyName: "",
          companyPerson: "",
          companyPhone: "",
          companyAddress: "",
          telemarketingNumber: "",
          isWechat: false,
          details: "",
          salesman: "",
          name: "",
          dataTime: moment(),
          visitLog: "",
          isInvite: false,
        };
      } else {
        if (Object.keys(this.selectRow).length !== 0) {
          this.isModalVisible = true;
          let list = this.selectRow[0];
          this.formData.id = list.id;
          this.formData.companyPerson = list.companyPerson;
          this.formData.companyName = list.companyName;
          this.formData.name = list.name;
          this.formData.companyAddress = list.companyAddress;
          this.formData.companyPhone = list.companyPhone;
          this.formData.telemarketingNumber = list.telemarketingNumber;
          this.formData.isWechat = list.isWechat;
          this.formData.salesman = list.salesman;
          this.formData.details = list.details;
          this.formData.dataTime = list.dataTime;
          this.formData.visitLog = list.visitLog;
          this.formData.isInvite = list.isInvite || false;
        } else {
          this.$Message.warning("请选择所要修改的一行！");
        }
      }
      this.formData.dataTime = moment(this.formData.dataTime).format(
        "YYYY-MM-DD 00:00:00"
      );
    },
    detailUpdateOk() {
      this.saveData(this.formData);
    },
    detailUpdateCancel() {
      this.$emit("close");
    },
    async saveData(params) {
      this.loading = true;
      await upsertCRM(params).then((res) => {
        if (res.statusCode == 200) {
          this.$Message.success("数据保存成功！");
          this.basicsData();
          this.selectRow[0] = params;
        } else {
          this.loading = false;
          this.$Message.error("数据保存失败！");
        }
      });
    },
    deleteData() {
      if (this.selectRow.length > 0) {
        let list = [];
        this.selectRow.forEach((item) => {
          list.push({ id: item.id });
        });
        this.$Modal.confirm({
          title: "操作提醒！！！",
          content: "您确定将该行删除么？",
          okText: "确定",
          cancelText: "取消",
          onOk: () => {
            deleteCRM(list).then((res) => {
              if (res.statusCode == 200) {
                this.$Message.success("数据删除成功！");
                this.basicsData();
              } else {
                this.$Message.error("数据删除失败！");
              }
            });
          },
          onCancel: () => {
            this.$message.info("您已取消操作！");
          },
        });
      } else {
        this.$Message.warning("请选择所要删除的数据行！");
      }
    },
    reset() {
      this.form = {
        companyName: "",
        companyPerson: "",
        companyPhone: "",
        salesman: "",
        isInvite: "",
      };
      this.startDate = null;
      this.endDate = null;
      this.timePicker = [null, null];
      this.basicsData();
    },
    customRow(record, index) {
      return {
        style: {
          // 字体颜色
          //color: "#cceaff",
          // 行背景色
          // "background-color": "#2a3347",
          cursor: "pointer",
        },
        on: {
          // 鼠标单击行
          click: (event) => {
            // this.taskCheckData(record);
          },
        },
      };
    },
    basicsData() {
      let params = {
        page: this.pagination.pageNo,
        size: this.pagination.pageSize,
        companyName: this.form.companyName,
        companyPerson: this.form.companyPerson,
        companyPhone: this.form.companyPhone,
        salesman: this.form.salesman,
        startTime: this.startDate ? moment(this.startDate).toISOString() : null,
        endTime: this.endDate ? moment(this.endDate).toISOString() : null,
        timeSearch: this.startDate && this.endDate ? "dataTime" : null,
        isInvite:
          this.form.isInvite === true
            ? "是"
            : this.form.isInvite === false
            ? "否"
            : "",
      };
      getCRMList(params).then((res) => {
        this.loading = false;
        if (res.data.list.length > 0) {
          this.isModalVisible = false;
          this.tolInformation = res.data.list;
          this.pagination.total = res.data.total;
        } else {
          this.tolInformation = [];
          this.pagination.total = 0;
        }
      });
    },
    async onPageChange(page) {
      this.pagination.pageNo = page;
      this.pagination.current = page;
      await this.basicsData();
    },
    searchData() {
      this.basicsData();
    },
    exportData() {
      let params = {};

      params = {
        header: [
          "记录日期",
          "公司名称",
          "负责人",
          "电话",
          "地址",
          "电销次数",
          "是否加微信",
          "是否邀约",
          "详情",
          "电销人员",
          "跟进情况",
          "拜访记录",
        ],
        headervalues: [
          "dataTime",
          "companyName",
          "companyPerson",
          "companyPhone",
          "companyAddress",
          "telemarketingNumber",
          "isWechat",
          "isInvite",
          "details",
          "salesman",
          "name",
          "visitLog",
        ],
        companyName: this.form.companyName,
        companyPerson: this.form.companyPerson,
        companyPhone: this.form.companyPhone,
        salesman: this.form.salesman,
        startTime: this.startDate ? moment(this.startDate).toISOString() : null,
        endTime: this.endDate ? moment(this.endDate).toISOString() : null,
        timeSearch: this.startDate && this.endDate ? "dataTime" : null,
        isInvite:
          this.form.isInvite === true
            ? "是"
            : this.form.isInvite === false
            ? "否"
            : "",
      };

      exportCRMList({ ...params }).then((data) => {
        if (!data || data.size <= 0) {
          this.$Message.error("没有数据导出失败");
          return;
        }

        let url = window.URL.createObjectURL(new Blob([data]));
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute(
          "download",
          `${moment().format("YYYY-MM-DD")}-CRM数据.xlsx`
        );

        document.body.appendChild(link);
        link.click();
      });
    },
  },
  mounted() {
    let roleId = Cookies.get("roleId");
    this.permissions = rolePermissions[roleId];
    this.basicsData();
  },
  computed: {
    rowSelection() {
      return {
        type: "radio",
        onChange: (selectedRowKeys, selectedRows) => {
          let ids = selectedRows.map((item) => {
            return item;
          });
          this.selectRow = ids;
        },
        onSelect: (record, selected, selectedRows) => {
          let ids = selectedRows.map((item) => {
            return item;
          });
          this.selectRow = ids;
        },
        onSelectAll: (selected, selectedRows, changeRows) => {
          let ids = selectedRows.map((item) => {
            return item;
          });
          this.selectRow = ids;
        },
      };
    },
  },
  watch: {
    // 表格高度自适应
    tolInformation: function (newVal, oldVal) {
      
      console.log('bbbbbbbbb',newVal);
      if (newVal.length == 0) {
        document.getElementsByClassName(
          "ant-spin-nested-loading"
        )[0].style.height = 40 + "px";
      } else {
        if (newVal.length != this.pageSize) {
          document.getElementsByTagName("table")[0].style.height = 0 + "px";
        } else {
          document.getElementsByClassName(
            "ant-spin-nested-loading"
          )[0].style.height = 100 + "%";
          document.getElementsByTagName("table")[0].style.height = 100 + "%";
        }
      }
    },
  },
};
</script>

<style lang="less">
.detalis {
  height: 100%;
  width: 100%;

  .search-btn {
    background: #14cc76;
    border-radius: 4px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #ffffff;
    border-color: #14cc76;
    width: 80px;
    height: 40px;
  }

  .search-btn:hover,
  .search-btn:active,
  .search-btn:focus {
    background: #14cc76;
    border-radius: 4px;
    color: #ffffff;
    border-color: #14cc76;
  }

  .search-normal {
    background: transparent;
    border-radius: 4px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #969998;
    border-color: #e3e6e4;
    width: 80px;
    height: 40px;
  }

  .search-normal:hover,
  .search-normal:active,
  .search-normal:focus {
    background: transparent;
    border-radius: 4px;
    color: #14cc76;
    border-color: #14cc76;
  }

  .search-delete {
    background: transparent;
    border-radius: 4px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #ff6b4d;
    border-color: #ff6b4d;
    width: 80px;
    height: 40px;
  }

  .search-delete:hover,
  .search-delete:active,
  .search-delete:focus {
    background: transparent;
    border-radius: 4px;
    color: #ff6b4d;
    border-color: #ff6b4d;
  }

  .search-page {
    background: transparent;
    border-radius: 4px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #14cc76;
    border-color: #14cc76;
    width: 104px !important;
    height: 40px;
  }

  .search-page:hover,
  .search-page:active,
  .search-page:focus {
    background: transparent;
    border-radius: 4px;
    color: #14cc76;
    border-color: #14cc76;
  }

  .search-cond {
    width: 100%;
    height: 200px;
    background: #ffffff;
    border-radius: 8px;
    margin-bottom: 16px;
    display: flex;
    flex-direction: column;
    padding: 24px;

    .search-input {
      width: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 16px;

      .search-item {
        width: calc(100% / 3);
        display: flex;
        align-items: center;

        .tol-title {
          width: 30%;
          display: flex;
          justify-content: flex-end;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 16px;
          color: #313332;
          line-height: 22px;
          font-style: normal;
          margin-right: 10px;
        }
      }
    }

    .search-button {
      margin-top: 8px;
      width: 100%;
      display: flex;
      align-items: center;

      .btn-cond {
        width: calc(100% / 3);
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
    }
  }
  .detalis-box {
    width: 100%;
    background: #ffffff;
    border-radius: 8px;
    padding: 24px;
    .title {
      display: block;
      border-bottom: solid 1px #384057;
      padding-bottom: 10px;
      overflow-wrap: break-word;
      color: rgba(255, 255, 255, 1);
      font-size: 20px;
      font-family: Alibaba-PuHuiTi-M;
      line-height: 28px;
      text-align: left;
    }
    .detalis-view {
      display: flex;
      margin-bottom: 20px;
      justify-content: space-between;
      width: 100%;
      height: 42px;
      .tol-item {
        display: flex;
        width: 70%;
        align-items: center;
        justify-content: flex-start;
        .tol-add {
          margin-left: 20px;
        }
        .tol-title {
          margin-right: 6px;
          overflow-wrap: break-word;
          color: rgba(207, 214, 230, 1);
          font-size: 16px;
          font-family: Roboto-Medium;
        }
        .Select-style {
          width: 336px;
          height: 40px;
        }
      }
      .last-page {
        display: flex;
        width: 30%;
        align-items: center;
        justify-content: flex-end;
      }
    }
    .detalis-table {
      height: calc(~"100% - 182px");
      padding-top: 4px;
      // 表格
      .detalis-table {
        height: 100%;
        .ant-checkbox-inner {
          background-color: transparent;
          border-color: rgba(132, 161, 219, 1);
        }
        //  点击时选框样式
        .ant-checkbox-wrapper-checked {
          .ant-checkbox-checked {
            background: #3384ff;
          }
        }
      }
    }
  }
}
</style>

<style lang="less" scoped>
/deep/ .ant-select-selection--single {
  height: 40px;
  display: flex;
  align-items: center;
  font-size: 16px;
}
/deep/ .ant-btn {
  width: 80px;
  height: 40px;
  font-size: 16px;
}

/deep/ .ant-table-thead {
  background: #f0f0f0;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #313332;
}

/deep/.ant-table-small > .ant-table-content > .ant-table-body {
  margin: 0;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #313332;
  line-height: 22px;
}

/deep/.ant-switch-checked {
  background: #14cc76;
}

/deep/ .ant-checkbox-wrapper-checked .ant-checkbox-checked {
  background: #14cc76;
}

/deep/ .ant-checkbox-inner {
  border: 1px solid #14cc76;
}

/deep/.ant-checkbox-indeterminate .ant-checkbox-inner::after {
  background: #14cc76;
}

/deep/ .ant-checkbox-checked::after {
  border: 1px solid #14cc76;
}

/deep/ .ant-spin-nested-loading {
  height: unset !important;
}

/deep/.ant-modal {
  display: flex;
  justify-content: center;
  width: 1200px !important;
}

/deep/.ant-modal-content {
  width: 1200px !important;
}

/deep/.ant-calendar-picker-input.ant-input {
  height: 40px !important;
}

/deep/.ant-form-item {
  justify-content: flex-end;
}
</style>
